import React, { useMemo, useState } from "react";

export default function OtpCaptchaPreview({ settings = [] }) {
  const map = useMemo(() => {
    const out = {};
    settings.forEach((x) => { out[x.key] = String(x.value ?? ""); });
    return out;
  }, [settings]);

  const [otpCode, setOtpCode] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");

  const otpOn = map.otp_required === "1";
  const captchaOn = map.captcha_required === "1";

  return (
    <div style={styles.wrap}>
      <div style={styles.headerRow}>
        <div>
          <h2 style={styles.title}>Front-end OTP and captcha preview</h2>
          <div style={styles.sub}>This stays on the Security page first. Later it can be moved into the real register form.</div>
        </div>
        <div style={styles.badges}>
          <span style={{ ...styles.badge, ...(otpOn ? styles.on : styles.off) }}>{otpOn ? "OTP ON" : "OTP OFF"}</span>
          <span style={{ ...styles.badge, ...(captchaOn ? styles.on : styles.off) }}>{captchaOn ? "Captcha ON" : "Captcha OFF"}</span>
        </div>
      </div>

      <div style={styles.grid}>
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Email OTP</h3>
          <p style={styles.text}>Preview only for now. Use this block in registration after the UI is approved.</p>
          <input style={styles.input} value={otpCode} onChange={(e) => setOtpCode(e.target.value)} placeholder="Enter 6-digit code" />
          <div style={styles.row}>
            <button style={styles.secondaryBtn} type="button">Send code</button>
            <button style={styles.primaryBtn} type="button">Verify code</button>
          </div>
        </div>

        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Captcha preview</h3>
          <p style={styles.text}>Simple front-end placeholder for now. You can later swap this for Google reCAPTCHA, hCaptcha, or your own image captcha.</p>
          <div style={styles.challenge}>Solve: <strong>4 + 7 = ?</strong></div>
          <input style={styles.input} value={captchaAnswer} onChange={(e) => setCaptchaAnswer(e.target.value)} placeholder="Type answer" />
          <button style={styles.primaryBtn} type="button">Validate captcha</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: { marginTop: 22, border: "1px solid #e5e7eb", borderRadius: 18, padding: 18 },
  headerRow: { display: "flex", justifyContent: "space-between", gap: 16, alignItems: "flex-start", marginBottom: 16 },
  badges: { display: "flex", gap: 8, flexWrap: "wrap" },
  badge: { borderRadius: 999, padding: "6px 12px", fontWeight: 800, fontSize: 13, border: "1px solid #d0d5dd" },
  on: { background: "#ecfdf3", color: "#067647" },
  off: { background: "#fff7ed", color: "#b54708" },
  title: { margin: 0, fontSize: 18, fontWeight: 800 },
  sub: { marginTop: 6, color: "#667085" },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 },
  card: { border: "1px solid #e5e7eb", borderRadius: 18, padding: 16 },
  cardTitle: { margin: "0 0 12px", fontSize: 18, fontWeight: 800 },
  text: { margin: "0 0 14px", color: "#555", lineHeight: 1.5 },
  input: { width: "100%", boxSizing: "border-box", border: "1px solid #d0d5dd", borderRadius: 12, padding: "12px 14px", marginBottom: 12, fontSize: 14 },
  row: { display: "flex", gap: 10, flexWrap: "wrap" },
  primaryBtn: { background: "#0d5d6c", color: "#fff", border: "none", borderRadius: 12, padding: "12px 16px", fontWeight: 800, cursor: "pointer" },
  secondaryBtn: { background: "#f3f4f6", color: "#111", border: "1px solid #e5e7eb", borderRadius: 12, padding: "12px 16px", fontWeight: 700, cursor: "pointer" },
  challenge: { border: "1px dashed #d0d5dd", borderRadius: 12, padding: "14px 16px", marginBottom: 12, fontSize: 16 },
};
